import React from 'react';
import './EmbedTestsPage.css';

const EmbedTestsPage = () => {
  const embedUrls = [
    {
      url: 'https://vis.snorkle.io/pjzwD4NqyVBh274KlIOYJ7ToAgutLVanCROub1bKCao=/viewer.html',
      title: 'Vertebral and spinal vasculature: how CSF venous leaks can form'
    },
    {
      url: 'https://vis.snorkle.io/Mo0F0N-fojdJkoa4SSNlyE9vOF6fPmyWQMDC2NnaH3M=/viewer.html',
      title: 'Crystal structure of mouse T-cadherin EC1'
    },
    {
      url: 'https://vis.snorkle.io/hh1WcqZ9qjxFGUhmUgIIevDCmXbInN0g0fET6d-LG68=/viewer.html',
      title: 'HEXOKINASE FROM SCHISTOSOMA MANSONI COMPLEXED WITH GLUCOSE'
    },
    {
      url: 'https://vis.snorkle.io/DuoqOFNBAtfo7FFlfsJARov7Yt-OrkiO8LzlTyUMB4s=/viewer.html',
      title: 'DICOM CT Myelogram'
    },
    {
      url: 'https://vis.snorkle.io/vTMWQZ21v-MFe4Z0EGcYA4Yiw1UewbRX5RF7h1H0aBk=/viewer.html',
      title: 'Colorized Veiled chameleon skull anatomy'
    },
    {
      url: 'https://vis.snorkle.io/gnoIvGlqZWu-SeLoBXKdYD2Mrqlnxtg_RnxTD2FK23U=/viewer.html',
      title: 'הדמיית טנזור דיפוזיה'
    },
    {
      url: 'https://vis.snorkle.io/explainers/gEpwp8jH5yoX_R7NK9B75qbJzfY=/viewer.html',
      title: 'תיאוריית השער בכאב מנקודת מבט פיזיותרפיסטית'
    },
    {
      url: 'https://vis.snorkle.io/_10ouR_SB5j9HhRr38ry01_CYfeTHqqXITL49s_8vRfP.html',
      title: 'Isomers!'
    },
    {
      url: 'https://vis.snorkle.io/dld_zG0jcG3UI2dCJbeYtmXN2iZPbChbqBRbrkGrW-A=/viewer.html',
      title: 'Fossil dig clip'
    }
  ];

  return (
    <div className="embed-tests-page">
      <div className="container py-5">
        <h1 className="text-center mb-4">Embed Tests</h1>
        <p className="text-center text-muted mb-5">
          Testing various visual types embedded as iframes
        </p>
        
        <div className="embed-grid">
          {embedUrls.map((item, index) => (
            <div key={index} className="embed-card">
              <h3 className="embed-title">{item.title}</h3>
              <div className="embed-container">
                <iframe
                  src={item.url}
                  width="640"
                  height="360"
                  title={item.title}
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
              <div className="embed-code-section">
                <p className="code-label">Embed Code:</p>
                <code className="embed-code">
                  {`<iframe src="${item.url}" width="640" height="360"></iframe>`}
                </code>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmbedTestsPage;
